import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { GettonciniIcon } from '../icons';
import FaIcon from './FaIcon';
import { summarizeGuestRewards, guestRewardLabel } from '../utils/guestRewardSummary';
import styles from '../styles/GameStartAccountOffer.module.css';

const rewardPanelStyles = {
  gettoncini: styles.gettonciniPanel,
  stelline: styles.stellinePanel,
  learned_terms: styles.learnedPanel,
};

const GameStartAccountOffer = ({ isReturningDevice, signupAmount, claims = [], authUrls, onAuthenticate, onContinue }) => {
  const rewards = summarizeGuestRewards(claims, isReturningDevice ? 0 : signupAmount);
  const primaryKind = isReturningDevice ? 'sign_in' : 'sign_up';
  const alternativeKind = isReturningDevice ? 'sign_up' : 'sign_in';
  return (
    <div className={styles.content}>
      {rewards.map((reward) => (
        <div key={reward.key} className={`${styles.rewardPanel} ${rewardPanelStyles[reward.resource]}`}>
          <span aria-hidden="true" className={reward.resource === 'stelline' ? styles.stellineIcon : reward.resource === 'learned_terms' ? styles.learnedIcon : undefined}>{reward.resource === 'gettoncini' ? <GettonciniIcon size={40} />
            : <FaIcon className={reward.resource === 'stelline' ? 'fa-solid fa-star' : 'fa-solid fa-learning-books'} />}</span>
          <div><div className={styles.amount}>+{reward.amount.toLocaleString('it-IT', { useGrouping: true })}</div>
            <div className={styles.rewardLabel}>{guestRewardLabel(reward)}</div></div>
        </div>
      ))}
      <p className={styles.body}>Crea un account gratuito o accedi per riscattare i premi.</p>
      <Button to={authUrls[primaryKind]} fullWidth className={styles.primaryCta} onClick={(event) => onAuthenticate(primaryKind, event)}>
        {isReturningDevice ? 'Accedi' : 'Registrati'}
      </Button>
      <p className={styles.alternative}>{isReturningDevice ? 'Non hai un account? ' : 'Hai già un account? '}
        <Link to={authUrls[alternativeKind]} className={styles.authLink} onClick={(event) => onAuthenticate(alternativeKind, event)}>
          {isReturningDevice ? 'Registrati' : 'Accedi'}
        </Link>
      </p>
      <button type="button" className={styles.continueButton} onClick={onContinue}>Continua senza account</button>
    </div>
  );
};
export default GameStartAccountOffer;
